export const UNKNOWN_ERROR_MESSAGE = 'Unknown error';

/**
 * Gets a readable message from a caught value, which may not be an `Error` (e.g. `throw 'text'`, `throw null`).
 * @param error The caught value.
 * @param fallback Message used when no message can be found. Defaults to {@link UNKNOWN_ERROR_MESSAGE}.
 * @returns The error's `message`, the value itself if it is a string, or `fallback`.
 */
export function getErrorMessage(error: unknown, fallback = UNKNOWN_ERROR_MESSAGE): string {
	if (error instanceof Error) {
		return error.message;
	}

	if (typeof error === 'string') {
		return error;
	}

	if (typeof error === 'object' && error !== null && 'message' in error && typeof error.message === 'string') {
		return error.message;
	}

	return fallback;
}
